
const tables = [
  { name: "Date", value: "Date" },
  { name: "Opening Balance", value: "Opening Balance" },
  { name: "Closing Balance", value: "Closing Balance" },
  { name: "Total Sales", value: "Total Sales" },
  { name: "Cash In", value: "Cash In" },
  { name: "Cash Out", value: "Cash Out" },
  { name: "Expenses", value: "Expenses" },
  { name: "Cash Difference", value: "Cash Difference" },
  { name: "Counted Cash", value: "Counted Cash" },
  { name: "Total Invoices", value: "Total Invoices" },
  { name: "Status", value: "Status" },
];

export default tables;